export function isEmailObviouslyMalformed(email: string): boolean {
  return !(email.includes("@") && email.includes("."));
}
